module.exports = __webpack_public_path__ + "img/lesson_plan.64aac81a.svg";